document.addEventListener('DOMContentLoaded', function() {
  const config = window.wishlistConfig || {};
  const userId = config.customerId;
  const isGuest = config.isGuest;
  const apiBaseUrl = config.apiBaseUrl;
  const STORAGE_KEY = 'hemlock_wishlist';
  const WISHLIST_CACHE_TTL = 5 * 60 * 1000;
  const WISHLIST_CACHE_KEY_PREFIX = 'hemlock_wishlist_api_';

  // --- localStorage helpers for guest mode ---

  function getGuestWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveGuestWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.error('Failed to save wishlist to localStorage', e);
    }
  }

  function addToGuestWishlist(item) {
    const items = getGuestWishlist();
    const exists = items.some(function(i) {
      return String(i.product_id) === String(item.product_id) &&
             String(i.variant_id || '') === String(item.variant_id || '');
    });
    if (!exists) {
      item.created_at = new Date().toISOString();
      items.push(item);
      saveGuestWishlist(items);
    }
    return !exists;
  }

  function removeFromGuestWishlist(productId, variantId) {
    const items = getGuestWishlist();
    const filtered = items.filter(function(i) {
      return !(String(i.product_id) === String(productId) &&
               String(i.variant_id || '') === String(variantId || ''));
    });
    saveGuestWishlist(filtered);
    return filtered.length < items.length;
  }

  function isInGuestWishlist(productId, variantId) {
    const items = getGuestWishlist();
    return items.some(function(i) {
      return String(i.product_id) === String(productId) &&
             String(i.variant_id || '') === String(variantId || '');
    });
  }

  // --- Sync guest wishlist to API on login ---

  function syncGuestWishlistToApi() {
    var guestItems = getGuestWishlist();
    if (!guestItems.length || !userId) return;

    var synced = 0;
    guestItems.forEach(function(item) {
      fetch(apiBaseUrl + '/api/wishlist/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          product_id: item.product_id,
          product_handle: item.product_handle || '',
          product_title: item.product_title || '',
          product_image: item.product_image || '',
          variant_id: item.variant_id || '',
          variant_title: item.variant_title || '',
          variant_image: item.variant_image || ''
        })
      }).then(function() {
        synced++;
        if (synced === guestItems.length) {
          localStorage.removeItem(STORAGE_KEY);
          console.log('Synced ' + synced + ' guest wishlist items to account');
          refreshWishlistCount(true);
        }
      }).catch(function(err) {
        console.error('Failed to sync guest item', err);
      });
    });
  }

  // If logged in and there are guest items, sync them
  if (!isGuest && userId) {
    syncGuestWishlistToApi();
  }

  // --- Header wishlist badge count ---

  var wishlistCount = 0;
  var wishlistFetchPromise = null;
  var wishlistCacheVersion = 0;

  function updateWishlistBadge(count) {
    wishlistCount = count;
    var badge = document.getElementById('wishlist-count');
    if (!badge) return;
    badge.textContent = count;
    if (count > 0) {
      badge.classList.remove('opacity-0');
    } else {
      badge.classList.add('opacity-0');
    }
  }

  function adjustWishlistBadge(delta) {
    updateWishlistBadge(Math.max(0, wishlistCount + delta));
  }

  function getWishlistCacheKey() {
    return WISHLIST_CACHE_KEY_PREFIX + userId;
  }

  function getCachedWishlistData() {
    if (!userId) return null;

    try {
      var rawCache = sessionStorage.getItem(getWishlistCacheKey());
      if (!rawCache) return null;

      var cached = JSON.parse(rawCache);
      if (!cached || typeof cached.expiresAt !== 'number' || Date.now() > cached.expiresAt || !Array.isArray(cached.wishlist)) {
        sessionStorage.removeItem(getWishlistCacheKey());
        return null;
      }

      return cached.wishlist;
    } catch (err) {
      console.error('Failed to read wishlist cache', err);
      return null;
    }
  }

  function saveWishlistCache(wishlist) {
    if (!userId) return;

    try {
      sessionStorage.setItem(getWishlistCacheKey(), JSON.stringify({
        expiresAt: Date.now() + WISHLIST_CACHE_TTL,
        wishlist: wishlist || []
      }));
    } catch (err) {
      console.error('Failed to save wishlist cache', err);
    }
  }

  function invalidateWishlistCache() {
    if (!userId) return;

    wishlistCacheVersion++;

    try {
      sessionStorage.removeItem(getWishlistCacheKey());
    } catch (err) {
      console.error('Failed to invalidate wishlist cache', err);
    }
  }

  async function fetchWishlistData(forceRefresh) {
    if (!userId || !apiBaseUrl) return null;
    if (!forceRefresh && wishlistFetchPromise) return wishlistFetchPromise;

    var requestVersion = wishlistCacheVersion;
    var fetchPromise = (async function() {
      try {
        var response = await fetch(apiBaseUrl + '/api/wishlist/' + userId);
        if (!response.ok) throw new Error('API returned status ' + response.status);

        var data = await response.json();
        var wishlist = data && Array.isArray(data.wishlist) ? data.wishlist : [];
        if (requestVersion !== wishlistCacheVersion) return null;

        saveWishlistCache(wishlist);
        return wishlist;
      } catch (err) {
        console.error('Failed to fetch wishlist data', err);
        return null;
      } finally {
        if (wishlistFetchPromise === fetchPromise) {
          wishlistFetchPromise = null;
        }
      }
    })();

    wishlistFetchPromise = fetchPromise;
    return wishlistFetchPromise;
  }

  async function getWishlistData(forceRefresh) {
    if (forceRefresh) {
      invalidateWishlistCache();
    } else {
      var cachedWishlist = getCachedWishlistData();
      if (cachedWishlist !== null) return cachedWishlist;
    }

    return fetchWishlistData(forceRefresh);
  }

  async function refreshWishlistCount(forceRefresh) {
    if (isGuest) {
      updateWishlistBadge(getGuestWishlist().length);
      return;
    }
    if (!userId || !apiBaseUrl) return;

    var wishlist = await getWishlistData(forceRefresh);
    if (wishlist !== null) {
      updateWishlistBadge(wishlist.length);
    }
  }

  // --- Header wishlist icon flash ---

  function flashHeaderWishlistIcon() {
    var link = document.querySelector('#wishlist-link');
    var icon = link ? link.querySelector('svg path') : null;
    if (!icon || !link) return;

    icon.setAttribute('fill', 'currentColor');
    link.classList.remove('wishlist-flash');
    void link.offsetWidth;
    link.classList.add('wishlist-flash');

    setTimeout(function() {
      icon.setAttribute('fill', 'none');
    }, 800);

    link.addEventListener('animationend', function() {
      link.classList.remove('wishlist-flash');
    }, { once: true });
  }

  function pulseProductButton(button) {
    button.classList.remove('wishlist-pulse');
    void button.offsetWidth;
    button.classList.add('wishlist-pulse');
    button.addEventListener('animationend', function() {
      button.classList.remove('wishlist-pulse');
    }, { once: true });
  }

  // --- Event delegation ---

  document.addEventListener('click', function(event) {
    // Square wishlist button next to ATC (or its SVG child)
    var squareBtn = event.target.closest('.wishlist-square-btn');
    if (squareBtn) {
      handleWishlistToggle(squareBtn);
      return;
    }

    if (event.target.classList.contains('remove-wishlist-item')) {
      removeWishlistItem(event.target);
      return;
    }

    // Move to wishlist from cart
    var moveBtn = event.target.closest('.move-to-wishlist');
    if (moveBtn) {
      event.preventDefault();
      moveToWishlist(moveBtn);
      return;
    }
  });

  // --- Variant change listener ---

  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      var variant = event.detail.variant;
      /* Product-page button only: card hearts (.wishlist-card-heart) track
         their own product's default variant and must not inherit the PDP's
         selection. Before this guard, querySelector could grab whichever
         .wishlist-square-btn happened to come first in the DOM. */
      var toggleButton = document.querySelector('.wishlist-square-btn:not(.wishlist-card-heart)');

      if (toggleButton) {
        toggleButton.setAttribute('data-variant-id', variant.id);
        toggleButton.setAttribute('data-variant-title', variant.title);

        // Update variant image
        if (variant.featured_image && variant.featured_image.src) {
          toggleButton.setAttribute('data-variant-image', variant.featured_image.src);
        } else {
          toggleButton.setAttribute('data-variant-image', toggleButton.getAttribute('data-product-image') || '');
        }
      }

      checkProductInWishlist();
    }
  });

  // --- Initialize ---

  refreshWishlistCount();
  checkProductInWishlist();

  // --- Core functions ---

  async function handleWishlistToggle(button) {
    var productId     = button.getAttribute('data-product-id');
    var variantId     = button.getAttribute('data-variant-id');
    var productHandle = button.getAttribute('data-product-handle');
    var productTitle  = button.getAttribute('data-product-title');
    var variantTitle  = button.getAttribute('data-variant-title');
    var productImage  = button.getAttribute('data-product-image');
    var variantImage  = button.getAttribute('data-variant-image');
    var inWishlist    = button.getAttribute('data-in-wishlist') === 'true';

    if (isGuest) {
      var success;

      if (inWishlist) {
        success = removeFromGuestWishlist(productId, variantId);
      } else {
        success = addToGuestWishlist({
          product_id: productId,
          product_handle: productHandle,
          product_title: productTitle,
          product_image: productImage,
          variant_id: variantId,
          variant_title: variantTitle,
          variant_image: variantImage
        });
      }

      if (success || !inWishlist) {
        var newState = !inWishlist;
        updateWishlistUI(button, newState);
        pulseProductButton(button);
        flashHeaderWishlistIcon();
        adjustWishlistBadge(newState ? 1 : -1);
      }
      return;
    }

    // --- Logged-in mode: use API ---
    try {
      var endpoint = inWishlist ? '/api/wishlist/remove' : '/api/wishlist/add';

      var res = await fetch(apiBaseUrl + endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify({
          user_id: userId,
          product_id: productId,
          variant_id: variantId,
          product_handle: productHandle,
          product_title: productTitle,
          variant_title: variantTitle,
          product_image: productImage,
          variant_image: variantImage
        })
      });
      var data = await res.json();

      if (data.success) {
        var newState = !inWishlist;
        updateWishlistUI(button, newState);
        pulseProductButton(button);
        flashHeaderWishlistIcon();
        adjustWishlistBadge(newState ? 1 : -1);
        refreshWishlistCount(true);
      }
    } catch (err) {
      console.error('Wishlist error', err);
    }
  }

  function updateWishlistUI(button, newState) {
    button.setAttribute('data-in-wishlist', newState ? 'true' : 'false');
    button.setAttribute('aria-label', newState ? 'Remove from Wishlist' : 'Add to Wishlist');
  }

  async function checkProductInWishlist(forceRefresh) {
    /* ALL buttons, not just the first: collection pages render one heart per
       product card (.wishlist-card-heart), and each needs its own state.
       One wishlist read (cached via getWishlistData) serves every button. */
    var toggleButtons = document.querySelectorAll('.wishlist-square-btn');

    if (!toggleButtons.length) return;

    function applyState(button, wishlist) {
      var currentProductId = button.getAttribute('data-product-id');
      var currentVariantId = button.getAttribute('data-variant-id');
      var inWishlist = wishlist.some(function(item) {
        return String(item.product_id).trim() === String(currentProductId).trim() &&
               (String(item.variant_id || '').trim() === String(currentVariantId || '').trim());
      });
      updateWishlistUI(button, inWishlist);
    }

    if (isGuest) {
      toggleButtons.forEach(function(button) {
        applyState(button, getGuestWishlist());
      });
      return;
    }

    var wishlist = await getWishlistData(forceRefresh);
    if (wishlist === null) return;

    toggleButtons.forEach(function(button) {
      applyState(button, wishlist);
    });
  }

  async function moveToWishlist(link) {
    var productId     = link.getAttribute('data-product-id');
    var variantId     = link.getAttribute('data-variant-id');
    var productHandle = link.getAttribute('data-product-handle');
    var productTitle  = link.getAttribute('data-product-title');
    var variantTitle  = link.getAttribute('data-variant-title');
    var productImage  = link.getAttribute('data-product-image');
    var variantImage  = link.getAttribute('data-variant-image');
    var lineKey       = link.getAttribute('data-line-key');

    var originalText = link.textContent;
    link.textContent = 'Moving\u2026';
    link.style.pointerEvents = 'none';
    link.style.opacity = '0.5';

    var item = {
      product_id: productId,
      product_handle: productHandle,
      product_title: productTitle,
      product_image: productImage,
      variant_id: variantId,
      variant_title: variantTitle,
      variant_image: variantImage
    };

    // Step 1: Add to wishlist first, wait for it to complete
    var wishlistAdded = false;
    if (isGuest) {
      addToGuestWishlist(item);
      wishlistAdded = true;
    } else if (userId && apiBaseUrl) {
      try {
        var wishlistRes = await fetch(apiBaseUrl + '/api/wishlist/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            product_id: productId,
            product_handle: productHandle,
            product_title: productTitle,
            product_image: productImage,
            variant_id: variantId,
            variant_title: variantTitle,
            variant_image: variantImage
          })
        });
        wishlistAdded = wishlistRes.ok;
      } catch (err) {
        console.error('Failed to add to wishlist', err);
      }
    }

    if (!wishlistAdded) {
      console.error('Wishlist add failed — not removing from cart');
      link.textContent = originalText;
      link.style.pointerEvents = '';
      link.style.opacity = '';
      return;
    }

    if (!isGuest) {
      refreshWishlistCount(true);
    }

    // Show confirmation briefly before removing
    link.textContent = 'Moved to Wishlist \u2713';
    link.style.opacity = '1';
    adjustWishlistBadge(1);
    flashHeaderWishlistIcon();

    // Step 2: Remove from cart via AJAX and refresh the drawer
    try {
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // Brief delay so the user sees the confirmation
      await new Promise(function(resolve) { setTimeout(resolve, 800); });

      var response = await fetch(rootPath + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0, sections: sectionsToBundle })
      });

      if (response.ok) {
        var cartContent = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'line-item:change', cart: cartContent }
        }));
      }
    } catch (err) {
      console.error('Failed to remove from cart', err);
    }
  }

  async function removeWishlistItem(button) {
    var productId = button.getAttribute('data-product-id');
    var variantId = button.getAttribute('data-variant-id');

    if (isGuest) {
      removeFromGuestWishlist(productId, variantId);
      adjustWishlistBadge(-1);
      checkProductInWishlist();
      return;
    }

    try {
      var response = await fetch(apiBaseUrl + '/api/wishlist/remove', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify({
          user_id: userId,
          product_id: productId,
          variant_id: variantId
        })
      });

      if (!response.ok) throw new Error('API returned status ' + response.status);

      var data = await response.json();
      if (data.success) {
        adjustWishlistBadge(-1);
        refreshWishlistCount(true);
        checkProductInWishlist();
      }
    } catch (error) {
      console.error('Error removing item:', error);
    }
  }
});


